module.exports = __webpack_public_path__ + "img/icon_messenger_hover.f9c4ac20.svg";